
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Listing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"resumeUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isProviderListing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookShareLink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stepOnePath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jsonldJobData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jsonldBreadcrumbsData"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBreadcrumbs"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkifiedHireReasons"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingDescription"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPhotos"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingFacets"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FooterLinks"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Conversation"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"similarListings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sisterListings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Profile"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"directoryJobDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyword"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"businessModel"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recommenders"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"largeUrl"},"arguments":[],"directives":[]}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingProfileFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1198}};
    doc.loc.source = {"body":"#import './ListingProfile/fragment.listingProfile.gql'\n#import './ProfileCard/fragment.profile.gql'\n#import './ListingDescription/fragment.description.gql'\n#import './HireReasons/fragment.hireReasons.gql'\n#import './Photos/fragment.photos.gql'\n#import './ListingFacets/fragment.listingFacets.gql'\n#import './FooterLinks/fragment.footerLinks.gql'\n#import './Messenger/fragment.messenger.gql'\n#import './Breadcrumbs/fragment.breadcrumbs.gql'\n\n\nquery Listing ($slug: String!) {\n  listing(slug:$slug) {\n    _id\n    id\n    slug\n    path\n    description\n    title  \n    resumeUrl\n    isProviderListing\n    facebookShareLink\n    stepOnePath\n    ownerName\n    jsonldJobData\n    jsonldBreadcrumbsData\n    ...ListingBreadcrumbs\n    ...LinkifiedHireReasons\n    ...ListingDescription\n    ...ListingPhotos\n    ...ListingFacets\n    ...FooterLinks\n    ...Conversation\n    similarListings(limit: 5) {\n      ...Profile\n    }\n    sisterListings {\n      ...Profile\n    }\n    site {\n      _id\n      directoryJobDescription\n      keyword\n      businessModel\n    }\n    recommenders {\n      firstName\n      lastName\n      avatarUrl\n      message\n    }\n    avatar {\n      largeUrl\n    }\n    ...ListingProfileFragment\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./ListingProfile/fragment.listingProfile.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ProfileCard/fragment.profile.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ListingDescription/fragment.description.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./HireReasons/fragment.hireReasons.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./Photos/fragment.photos.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./ListingFacets/fragment.listingFacets.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FooterLinks/fragment.footerLinks.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./Messenger/fragment.messenger.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./Breadcrumbs/fragment.breadcrumbs.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Listing"] = oneQuery(doc, "Listing");
        
